/* eslint-disable @typescript-eslint/ban-ts-comment */
import { Timestamp } from '@weblite-wapps/protocol'
import { addModal, closeCurrentModal } from 'weblite-web-modal-viewer'
import {
  ChooseHallCallTime,
  HallCallTime,
  HallCallType,
} from './choose-hall-call-time'

const COMPONENT_ID = 'chooseCallTime'

const showChooseHallCallTime = (
  props: Parameters<typeof ChooseHallCallTime>[0],
) => addModal({ id: COMPONENT_ID, props })

export const showChooseHallCallTimeDialog = ({
  callType,
  onBack,
  hallType,
  defaultTitle,
  defaultShouldSendNotification,
  editMode,
  defaultTime,
}: {
  callType: HallCallType
  onBack?: () => unknown
  hallType: 'CHANNEL' | 'GROUP'
  defaultTitle?: string
  defaultShouldSendNotification?: boolean
  editMode?: boolean
  defaultTime?: Date
}): Promise<HallCallTime | 'DELETE'> =>
  new Promise((resolve, reject) =>
    showChooseHallCallTime({
      callType,
      hallType,
      defaultShouldSendNotification,
      defaultTitle,
      editMode,
      defaultTime,
      onDelete: async () => {
        await closeCurrentModal()
        resolve('DELETE')
      },
      onConfirm: async callTime => {
        resolve(callTime)
        await closeCurrentModal()
      },
      onCancel: async () => {
        reject()
        await closeCurrentModal()
      },
      onBack,
    }),
  )

export default {
  [COMPONENT_ID]: {
    Component: ChooseHallCallTime,
  },
}
